import { useEffect, useState } from "react";
import axios from "axios";
import { Quote, Star } from "lucide-react";
import { API } from "@/lib/api";

export function HomeTestimonials() {
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(`${API}/public/testimonials`).then((r) => setData(r.data)).catch(() => setData({ enabled: false })); }, []);
  if (!data || data.enabled === false || (!data.logos?.length && !data.quotes?.length)) return null;
  return (
    <section id="clienti" className="bg-[#0B1F4B]">
      <div className="mx-auto max-w-7xl px-5 py-20">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-emerald-400">Si fidano di noi</p>
        <h2 className="font-display mt-2 text-center text-3xl font-extrabold text-white sm:text-4xl">{data.title}</h2>
        {data.logos?.length > 0 && (
          <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-testid="home-client-logos">
            {data.logos.map((l, i) => (
              <div key={`${l.name}-${i}`} className="flex h-16 items-center justify-center rounded-xl border border-white/10 bg-white/5 px-3 text-center font-display text-sm font-bold tracking-wide text-blue-100" title={l.name}>
                {l.image_url ? <img src={l.image_url} alt={l.name} className="max-h-10 max-w-full object-contain" /> : l.name}
              </div>
            ))}
          </div>
        )}
        {data.quotes?.length > 0 && (
          <div className="mt-12 grid gap-5 md:grid-cols-3" data-testid="home-testimonials">
            {data.quotes.map((q, i) => (
              <figure key={`${q.name}-${i}`} className="relative rounded-2xl bg-white p-6 text-slate-900 shadow-xl shadow-blue-950/30">
                <Quote className="absolute -top-3 left-5 h-7 w-7 rounded-full bg-emerald-500 p-1.5 text-white" />
                <div className="flex gap-0.5 text-amber-400">{[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-current" />)}</div>
                <blockquote className="mt-3 text-sm leading-relaxed text-slate-700">“{q.text}”</blockquote>
                <figcaption className="mt-4 text-sm"><b className="text-slate-900">{q.name}</b><span className="block text-xs text-slate-500">{q.role}</span></figcaption>
              </figure>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
